<!-- Page content -->
<div class="container-fluid mt-5">
    <!-- Table -->
    <div class="row">
        <div class="col">
            <div class="card shadow">
                <div class="card-header border-0">
                    <div class="row no-gutters" id="fillDates">
                        <div class="col-xl-6 pb-3">
                            <div class="w-100">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="h2 text-uppercase">Prix de la session</div>
                                    <div *ngIf="!loading" class="text-danger h2 font-weight-bolder">
                                        {{currentStudio.price}} € / HEURE
                                    </div>
                                    <!-- shimmer -->
                                    <div *ngIf="loading" class="shimmer w-50 mb-2" style="height: 30px;"></div>
                                </div>
                                <div class="d-flex align-items-center border rounded border-gray-200 p-4 mb-3">
                                    <img *ngIf="!loading" [src]="currentStudio.thumbnail" alt="studio" height="100"
                                        width="100" class="object-cover rounded">
                                    <div *ngIf="!loading" class="p-3">
                                        <span class="h2">{{currentStudio.name}}</span>
                                        <br>{{currentStudio.postal_code}}
                                        {{currentStudio.city}} {{currentStudio.country}}
                                    </div>
                                    <!-- shimmer -->
                                    <div *ngIf="loading" class="shimmer w-50 mb-4" style="height: 150px;"></div>
                                    <div *ngIf="loading" class="w-100 p-3">
                                        <div class="shimmer w-50" style="height: 25px;"></div><br>
                                        <div class="shimmer w-75" style="height: 20px;"></div>
                                    </div>
                                </div>
                                <div class="">
                                    <h4><strong>Début : </strong>{{selectedStartDate}}</h4>
                                    <h4><strong>Fin : </strong>{{selectedEndDate}}</h4>
                                </div>

                                <div class="mt-3 pt-3 border-top">
                                    <div class="h2 text-uppercase">Détails du paiement</div>
                                    <h4 class="d-flex justify-content-between"><strong>{{currentStudio?.price}}€ x
                                            {{form.get("nbr_hours")?.value}} heures :
                                        </strong>{{(form.get('startDate')?.value) ?
                                        currentStudio.price * form.get("nbr_hours")?.value : "---" }} €</h4>
                                    <h4 class="d-flex justify-content-between"><strong>Frais fixes :
                                        </strong>{{(form.get('startDate')?.value) ?
                                        price_fees?.fc : "---" }} €</h4>
                                    <h4 class="d-flex justify-content-between"><strong>Frais variables :
                                        </strong>{{(form.get('startDate')?.value) ? price_fees?.vc : "---" }} %</h4>
                                    <h4 class="d-flex justify-content-between"><strong>TVA :
                                        </strong>{{(form.get('startDate')?.value) ?
                                        price_fees?.tva : "---" }} %</h4>
                                    <hr class="my-2">
                                    <h4 class="d-flex justify-content-between">
                                        <strong>Total : </strong>
                                        <span *ngIf="!promo_code_is_valid && !discount_periods_found"><strong>{{ (form.get('startDate')?.value) ?
                                                final_price : "---" }}
                                                €</strong></span>
                                        <span *ngIf="promo_code_is_valid || discount_periods_found"><del><strong>{{ (form.get('startDate')?.value)
                                                    ? final_price : "---" }}
                                                    €</strong></del></span>
                                    </h4>

                                    <h4 class="d-flex justify-content-between" *ngIf="promo_code_is_valid || discount_periods_found">
                                        <strong>Réduction : </strong><span><strong class="text-danger">-{{ reduce_value
                                                }} €</strong></span>
                                    </h4>
                                    <h4 class="d-flex justify-content-between" *ngIf="promo_code_is_valid || discount_periods_found">
                                        <strong>Montant à payer : </strong><strong>{{ final_price_after_apply_promo }}
                                            €</strong>
                                    </h4>
                                </div>
                            </div>

                        </div>
                        <div class="col-xl-6 pl-xl-3 pl-0">
                            <form [formGroup]="form" (ngSubmit)="onSubmit()">
                                <div class="form-group">
                                    <label for="startDate">Sélectionnez une date</label>

                                    <div class="input-group m-0">
                                        <input id="startDate" class="form-control m-0" placeholder="jj/mm/aaaa"
                                            formControlName="startDateMockup" [minDate]="toDay" ngbDatepicker
                                            #d1="ngbDatepicker" [dayTemplate]="customDay">
                                        <div class="input-group-append">
                                            <button class="btn button-radius-right btn-studiomap"
                                                (click)="d1.toggle(); dropdownOpen = false" type="button"><i
                                                    class="fas fa-calendar-alt"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="startHour">Sélectionnez l'heure</label>
                                    <div class="dropdown w-100 position-relative">
                                        <button
                                            class="form-control text-start d-flex justify-content-between align-items-center"
                                            type="button"
                                            [ngClass]="{'border-danger': formControl.startTime.errors && submitted}"
                                            (click)="toggleDropdown()">
                                            <span>
                                                {{ form.value.startTime }}
                                            </span>
                                            <div class="">
                                                <span *ngIf="getDiscountRateForHour(form.value.startTime)"
                                                    class="badge bg-studiomap rounded-pill text-white mr-2">
                                                    - %{{ getDiscountRateForHour(form.value.startTime) }}
                                                </span>
                                                <i class="fa fa-chevron-down"></i>
                                            </div>
                                        </button>

                                        <ul *ngIf="dropdownOpen" class="dropdown-menu show w-100 shadow-sm mt-1"
                                            style="max-height: 250px; overflow-y: auto;">
                                            <li class="dropdown-item d-flex justify-content-between align-items-center"
                                                *ngFor="let hour of hours" (click)="selectHour(hour)"
                                                [class.active]="selectedHour?.value === hour.value"
                                                style="cursor: pointer;">
                                                {{ hour }}
                                                <span *ngIf="getDiscountRateForHour(hour)"
                                                    class="badge bg-studiomap rounded-pill text-white ms-2">
                                                    - %{{ getDiscountRateForHour(hour) }}
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="numberOfHours">Nombre d'heures</label>
                                    <input [ngClass]="{'border-danger':formControl.nbr_hours.errors && submitted}"
                                        formControlName="nbr_hours" type="number" class="form-control"
                                        id="numberOfHours" [attr.min]="currentStudio?.nbr_min_hours" max="23" step="1">
                                </div>
                                <div class="form-group">
                                    <label for="promoCode">Code promotionnel</label>
                                    <div class="input-group mb-1" *ngIf="!promo_code_is_valid">
                                        <input formControlName="promo_code" type="text" class="form-control"
                                            id="promoCode" placeholder="Entrez le code promotionnel">
                                        <div class="input-group-append">
                                            <button class="btn btn-secondary" type="button"
                                                *ngIf="checking_promo_code"><i class="fa fa-spinner fa-spin"
                                                    style="font-size:24px"></i></button>

                                            <button class="btn btn-studiomap" type="button" (click)="check_promo_code()"
                                                *ngIf="!checking_promo_code">Valider</button>
                                        </div>
                                    </div>
                                    <div class="input-group mb-1" *ngIf="promo_code_is_valid">
                                        <input formControlName="promo_code" type="text" class="form-control"
                                            id="promoCode" placeholder="Entrez le code promotionnel" readonly>
                                        <div class="input-group-append">
                                            <button class="btn btn-studiomap" type="button"
                                                (click)="dettach_promo_code()">X</button>
                                        </div>
                                    </div>
                                    <small class="form-text text-danger" *ngIf="promo_code_error != ''">{{
                                        promo_code_error }}</small>
                                </div>
                                <div class="d-flex align-items-center">
                                    <div class="w-100 text-center">
                                        <button
                                            [disabled]="selectedStartDate=='--- ---' || selectedStartDate=='--- ---'"
                                            class="btn btn-studiomap btn-block w-100" type="submit">Valider</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <!-- calendar -->
                            <mwl-demo-utils-calendar-header class="w-100 p-4" [(view)]="view" [(viewDate)]="viewDate"
                                [events]="events" [userType]="'artist'"
                                (timeRangeSelected)="fillCalendarWithSelectedRange($event)"
                                (emittedSelectedDate)="getSelectedDate($event)">
                            </mwl-demo-utils-calendar-header>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled"
    let-focused="focused">
    <div class="custom-day-wrapper" [class.hidden]="date.month !== currentMonth">
        <span class="custom-day" [class.weekend]="isDiscountDay(date)" [class.focused]="focused"
            [class.bg-studiomap]="selected" [class.text-muted]="disabled">
            {{ date.day }}
        </span>
        <div *ngIf="isDiscountDay(date)" class="percent-icon">%</div>
    </div>
</ng-template>